const BackendDrivenEvents = {};
let vueInstance = null;

BackendDrivenEvents.install = function (Vue) {
    const storeVM = new Vue({
        data() {
            return {
                refreshApps: false,
                refreshAppPermissions: false,
                refreshTasks: false,
                refreshGuiList: false,
                refreshCatList: false,
                taskDataNotifications: ""
            };
        }
    });

    // Add an instance method

    Vue.prototype.$backendDrivenEvents = {
        startWebsocket() {
            const { host } = window.location;
            const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

            const websocket = new WebSocket(`${protocol + host}/websocket/update`);

            const tm = setTimeout(() => {}, 5000);
            function ping() {
                websocket.send("__ping__");
            }
            function pong() {
                clearTimeout(tm);
            }

            websocket.onopen = function () {
                setInterval(ping, 30000);
            };

            websocket.onmessage = (ev) => {
                const msg = ev.data;
                if (msg && msg.includes("maintenance")) {
                    const action = msg.split(":")[1];
                    const message = msg.split(":").slice(2).join(":");
                    if (action === "schedule") {
                        localStorage.setItem("maintenanceSchedule", true);
                        localStorage.setItem("maintenanceMessage", message);
                        vueInstance.$emit("maintenanceScheduled");
                    } else if (action === "start") {
                        localStorage.removeItem("maintenanceMessage");
                        localStorage.removeItem("maintenanceSchedule");
                        localStorage.setItem("maintenanceStarted", true);
                        vueInstance.$emit("maintenanceStarted");
                    } else if (action === "stop") {
                        localStorage.removeItem("maintenanceMessage");
                        localStorage.removeItem("maintenanceSchedule");
                        vueInstance.$emit("maintenanceScheduled");
                    }
                    return;
                }
                if (msg && msg.includes(":") && !msg.includes("refreshGuiList")) {
                    const pattern = new RegExp("^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$", "i");
                    if (msg.split(" : ")[1].match(pattern)) {
                        vueInstance.$emit("backendDrivenEvents-taskDataNotifications");
                        storeVM.taskDataNotifications = msg;
                    }
                }
                if (msg === "__pong__") {
                    pong();
                    return;
                }
                if (msg === "updatePrincipal") {
                    vueInstance.$store.dispatch("userProfile/refreshPrincipal").then(() => {
                        vueInstance.$emit("backendDrivenEvents-refreshApps");
                        storeVM.refreshApps = true;
                        storeVM.refreshAppPermissions = true;
                    });
                } else if (msg === "refreshTasks") {
                    vueInstance.$emit("backendDrivenEvents-refreshTasks");
                    storeVM.refreshTasks = true;
                } else if (msg === "refreshApps") {
                    vueInstance.$emit("backendDrivenEvents-refreshApps");
                    storeVM.refreshApps = true;
                }
            };
            websocket.onerror = (error) => {
                console.log(`WebSocket error ${error}`);
            };
        },
        init(mainVueInstance) {
            vueInstance = mainVueInstance;
            this.startWebsocket();
        },
        get state() {
            return storeVM.$data;
        }
    };
};

export default BackendDrivenEvents;
